import { ModuleProperties } from '@/lib/core/types';
import { RteBlockElementModel } from '@/services/platform/api/model';
import parse from 'html-react-parser';
import ModuleWrapper from '@/components/shared/module/wrapper';

export const RteBlock = (props: ModuleProperties) => {
  const content = props.content as RteBlockElementModel | undefined;
  const raw = (content?.properties as { text?: string | { markup?: string } })?.text;
  const html = typeof raw === 'string' ? raw : (raw as { markup?: string } | undefined)?.markup;

  return (
    <ModuleWrapper
      component={props}
      isFullWidth={true}
      classNames={{
        base: 'module__rte-block',
        wrapper: 'py-0 lg:py-0',
        grid: 'grid-cols-1 lg:grid-cols-1 gap-0',
      }}
    >
      <div className="col-span-1 px-4 py-8 text-white">
        {html ? (
          <div className="home-rte prose prose-invert max-w-none">{parse(html)}</div>
        ) : (
          <div className="flex flex-col text-center">
            <span className="font-pp-neue-montreal text-[24px] leading-tight font-semibold tracking-[0.5px] uppercase">
              DISCOVER
            </span>
            <span
              className="font-didot text-[36px] leading-tight italic"
              style={{ letterSpacing: '-1.44px' }}
            >
              WHAT&apos;S ON
            </span>
            <span className="font-pp-neue-montreal text-[24px] leading-tight font-semibold tracking-[0.5px] uppercase">
              IN OUR WORLD
            </span>
          </div>
        )}
      </div>
    </ModuleWrapper>
  );
};
